window.addEventListener('load', () => {
    const datalayer = window.dataLayer;
    loadPageReadyEvent(datalayer);
    loadClickMenuEvent(datalayer);
    loadClickCityEvent(datalayer);
    loadClickNews(datalayer);
    loadClickSocialNetwork(datalayer);
    loadClickJobOffer(datalayer);
    loadSocialNetworkJob(datalayer);
    loadMailLukla(datalayer);
    loadPhoneLukla(datalayer);
    loadSubmitContactFormEvent(datalayer);
});

function loadPageReadyEvent(datalayer) {
    let layerObject = {
        'event': 'page_ready',
    };
    datalayer.push(layerObject);
}

function loadClickMenuEvent(datalayer) {
    const menuLinks = document.querySelectorAll('header .wp-block-navigation__container a[href]');
    menuLinks.forEach(link => {
        link.addEventListener('click', () => {
            let layerObject = {
                'event': 'click_menu'
            };

            let isSubmenu = link.closest('.wp-block-navigation__submenu-container');

            if (isSubmenu) {
                let parentMenu = link.closest('.wp-block-navigation__submenu-container').previousElementSibling;
                if (parentMenu) {
                    layerObject['menu_niveau_1'] = parentMenu.textContent;
                }
                layerObject['menu_niveau_2'] = link.textContent;
            } else {
                layerObject['menu_niveau_1'] = link.textContent;
            }

            datalayer.push(layerObject);
        });
    });
}

function loadClickCityEvent(datalayer) {
    const cityListItems = document.querySelectorAll('.maps__cities li');
    cityListItems.forEach(city => {
        city.addEventListener('click', () => {
            let layerObject = {
                'event': 'click_city'
            };
            layerObject['city_name'] = city.textContent.trim();
            datalayer.push(layerObject);
        });
    });
}

function loadClickNews(dataLayer) {
    const newsLinks = document.querySelectorAll('.type-post');
    newsLinks.forEach(newsItem => {
        newsItem.addEventListener('click', (event) => {
            event.preventDefault();
            let newsTitle = newsItem.querySelector('h2 a') ? newsItem.querySelector('h2 a').textContent.trim() : 'Sans titre';
            let layerObject = {
                'event': 'news-click',
                'news_title': newsTitle
            };
            dataLayer.push(layerObject);
        });
    });
}

function loadClickSocialNetwork(dataLayer) {
    const iconsSocialNetwork = document.querySelectorAll('.social-icons p');

    iconsSocialNetwork.forEach(socialNetwork => {
        socialNetwork.addEventListener('click', () => {
            const iconElement = socialNetwork.querySelector('i');

            if (iconElement) {
                const iconClass = Array.from(iconElement.classList).find(className => className.startsWith('i-'));

                if (iconClass) {
                    const socialNetworkName = iconClass.replace('i-', '');
                    console.log(socialNetworkName);

                    let layerObject = {
                        'event': 'social-click',
                        'social_network': socialNetworkName
                    };
                    dataLayer.push(layerObject);
                }
            }
        });
    });
}

function loadClickJobOffer(dataLayer) {
    const jobsOffer = document.querySelectorAll('.job-offer');

    jobsOffer.forEach(jobOffer => {
        jobOffer.addEventListener('click', () => {
            const jobTitle = jobOffer.querySelector('p').textContent;
            let layerObject = {
                'event': 'offer-click',
                'offer_title': jobTitle
            };
            dataLayer.push(layerObject);
        });
    });
}

function loadSocialNetworkJob(dataLayer) {
    const SocialsNetworkPro = document.querySelectorAll('.job-offer-line  > div:last-child');

    SocialsNetworkPro.forEach(SocialNetworkPro => {
        let SocialNetwork = SocialNetworkPro.querySelector('a');
        if (SocialNetwork) {
            SocialNetwork.addEventListener('click', () => {
                let layerObject = {
                    'event': 'pro-network-click',
                    'network_title': SocialNetwork.textContent.trim()
                };
                dataLayer.push(layerObject);
            });
        }
    });
}

function loadMailLukla(dataLayer) {
    const links = document.querySelectorAll('a[href*="@luklagroup.com"]');

    links.forEach(link  => {
        if (link) {
            link.addEventListener('click', () => {
                let layerObject = {
                    'event': 'mail-click',
                    'mail_address': link.textContent.trim()
                };
                dataLayer.push(layerObject);
            });
        }
    });
}

function loadPhoneLukla(dataLayer) {
    const phones = document.querySelectorAll('a[href^="tel:"]');

    phones.forEach(phone  => {
        if (phone) {
            phone.addEventListener('click', () => {
                console.log(phone.textContent.trim());
                const newPhoneFormat = formatPhoneNumber(phone.textContent.trim());
                let layerObject = {
                    'event': 'phone-click',
                    'phone_number': newPhoneFormat
                };
                dataLayer.push(layerObject);
            });
        }
    });
}

function loadSubmitContactFormEvent(datalayer) {
    let wpcf7Elm = document.querySelector('.wpcf7-form');
    if (wpcf7Elm) {
        wpcf7Elm.addEventListener('submit', function (event) {
            let selectedDemande = wpcf7Elm.querySelector('.wpcf7-select option:checked');
            let layerObject = {
                'event': 'submission-form',
                'mail_subject': selectedDemande.value
            };

            datalayer.push(layerObject);
        }, false);
    }
}

function formatPhoneNumber(phone) {
    return phone.replace(/[^\d]/g, '');
}
